import { http } from '@packet/management/src/api/http';

// 搜索结果接口定义
export interface SearchResultTransaction {
  type: 'transaction';
  txhash: string;
  tx_index: number;
  chain_id: number;
}

export interface SearchResultCommitment {
  type: 'commitment';
  commitment: string;
  chain_id: number;
}

export type SearchResult = SearchResultTransaction | SearchResultCommitment;

// 搜索请求参数
export interface SearchParams {
  query: string;
  limit: number;
}

/**
 * 搜索交易和UTXO
 */
export const searchAPI = async (params: SearchParams) => {
  return http().get<SearchResult[]>('/api/v1/search', params);
};
